import { useEffect } from "react";
function useVideoPlayerError(leadingPlayer, instances) {
    useEffect(() => {
        const handleErrorPlayers = () => {
            leadingPlayer.current?.canPlayQueue.stop();
            leadingPlayer.current?.el?.setAttribute("data-error", "true");
            instances.current?.map((instance) => {
                instance.canPlayQueue.stop();
            });
        };
        leadingPlayer.current?.addEventListener("error", () => handleErrorPlayers());
        instances.current?.map((instance) => instance.addEventListener("error", () => handleErrorPlayers()));
        return () => {
            leadingPlayer.current?.removeEventListener("error", () => { });
            instances.current?.map((instance) => instance.addEventListener("error", () => { }));
        };
    }, [leadingPlayer, instances]);
}
export default useVideoPlayerError;
